import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface SortableItemProps {
  id: string;
  index: number;
  children: React.ReactNode;
  disabled?: boolean;
}

export const SortableItem: React.FC<SortableItemProps> = ({ id, index, children, disabled = false }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled, // Disable dragging when disabled prop is true
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1000 : 'auto', // Ensure the dragged item appears on top
  };

  const className = `relative ${index === 0 ? 'image-grid-item-large' : 'image-grid-item'} ${
    isDragging ? 'dragging' : ''
  }`;

  return (
    <div
      id={`image-grid-item-${index}`}
      ref={setNodeRef}
      style={style}
      className={className}
      // Only add drag attributes and listeners if not disabled
      {...(!disabled ? attributes : {})}
      {...(!disabled ? listeners : {})}
    >
      {React.cloneElement(children as React.ReactElement, { 'data-is-dragging': isDragging })}
      {/* The tile in the air says so. Half a dozen near-identical thumbnails
          fading by 50% is not a state anyone reads as "this is the one you
          picked up" — the design labels it, so it is labelled. */}
      {isDragging && <span className="dragging-label">dragging…</span>}
    </div>
  );
};
